// import firebase from "../firebaseConfig";
import * as auth from '../app/modules/Auth/_redux/authRedux'
// import * as crud from '../app/modules/App/_redux/User/UserCrud'
// import jwt_decode from "jwt-decode";

export default function setupAxios(axios, store) {
  axios.interceptors.request.use(
    config => {
      const {
        auth: { authToken }
      } = store.getState();

      if (authToken) {
        config.headers.Authorization = `Bearer ${authToken}`;
      }

      return config;
    },
    err => Promise.reject(err)
  );

  axios.interceptors.response.use((response) => {
    return response
 }, async function (error) {
 // const originalRequest = error.config;
   if (error?.response?.status === 401 || error?.response?.status === 400 ) {
    store.dispatch(auth.actions.logout())
    //If ID TOKEN Expired we need to refresh it.
    //   firebase.auth().onAuthStateChanged(function(user) {
    //     if (user) {
    //       let promise = crud.getUserById(user.uid)


		// 			Promise.resolve(promise).then(function(userData) {
		// 				store.dispatch(auth.actions.fulfillUser(userData.data));
		// 			});

		// 			user.getIdToken(true)
		// 			.then(async function(authToken) {

		// 				store.dispatch(auth.actions.setAuthToken(authToken));
		// 				return axios(originalRequest);
		// 			}).catch(function(error) {
		// 				store.dispatch(auth.actions.logout())
		// 			});
          
    //     //  user.getIdToken(true)
    //     //  .then(async function(idToken) {
    //     //    let user = jwt_decode(idToken);
    //     //    store.dispatch(auth.actions.fulfillUser(user))

    //     //   //  store.dispatch(auth.actions.login(idToken));
    //     //    return axios(originalRequest);
    //     //  }).catch(function(error) {
    //     //    store.dispatch(auth.actions.logout())
    //     //  });
    //     }
    //     else {
    //      store.dispatch(auth.actions.logout())
    //     }
    //  });
    }
    return Promise.reject(error);
 });
}
